import React from 'react'
import Packages from '../../ui/views/Packages/Packages'

const PackagesRoute = () => {
  return (
    <div>
        <Packages></Packages>
    </div>
  )
}

export default PackagesRoute